// eslint-disable-next-line import/prefer-default-export
export const WRAPPER_WIDTH = 1440;
export const FONT_FILE_NAMES = {
  book: "ABCWhyte-Book",
  medium: "ABCWhyte-Medium",
  bold: "ABCWhyte-Bold",
  heavy: "ABCWhyte-Heavy",
};
